<div class="row">
  <div #allNews class="col-md-6 col-12 mt-3" *ngFor="let n of pagedItems">
    <div class="row">

      <div class="col-3" *ngIf="n.imgSrc != null">
        <img [src]="n.imgSrc" style="max-width: 100%;">
      </div>
      <div class="col-3" *ngIf="n.imgSrc == null">
        <img src="../../assets/images/dpa_news_logo.png" style="max-width: 100%;">
      </div>

      <div class="col-9 news-header">
        <a target="_blank" href="/news/{{n.dpa_newandactivityid}}">{{n.dpa_name}}</a>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <img src="../../assets/images/calendar_icon.png" width="15">
        <label class="text-secondary">{{ n.dpa_startdate | thaidate:'short'}}</label>
        <!-- <span class="fa fa-eye text-secondary"></span>
        <label class="text-secondary">0</label> -->
      </div>
      <div class="col-12">
        <hr class="w-100 m-1">
      </div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item {{pager.currentPage === 1 ? 'disabled' : ''}}">
          <span class="page-link" (click)="setPage(1)">|<</span>
        </li>
        <li class="page-item {{pager.currentPage === 1 ? 'disabled' : ''}}">
          <span class="page-link" (click)="setPage(pager.currentPage - 1)"><</span>
        </li>
        <li *ngFor="let page of pager.pages" class="page-item {{pager.currentPage === page ? 'active' : ''}}">
          <span class="page-link" (click)="setPage(page)">{{page}}</span>
        </li>
        <li class="page-item {{pager.currentPage === pager.totalPages ? 'disabled' : ''}}">
          <span class="page-link" (click)="setPage(pager.currentPage + 1)">></span>
        </li>
        <li class="page-item {{pager.currentPage === pager.totalPages ? 'disabled' : ''}}">
          <span class="page-link" (click)="setPage(pager.totalPages)">>|</span>
        </li>
      </ul>
    </nav>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/all-news/all-news.component.html